import { Quote, Star } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const TESTIMONIALS = [
  {
    quote:
      "My son was able to open up and talk about his problems with her. A lot of conflicts have resolved, and counselling still helps his well-being.",
    author: "Mamta",
    tag: "Child & Family Counselling",
  },
  {
    quote:
      "My daughter had a lot of body image issues, and I can confidently say she has been recovering from it well.",
    author: "Alice",
    tag: "Teen & Body Image Support",
  },
  {
    quote:
      "Through play-based therapy, my 5-year-old has now become more confident in speech and development.",
    author: "Vedant",
    tag: "Child Play Therapy",
  },
];

export default function Testimonials() {
  return (
    <section id="stories" data-testid="testimonials-section" className="bg-[#FDFBF7] py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
        <Reveal className="mb-12 max-w-2xl lg:mb-16">
          <Eyebrow>Kind words</Eyebrow>
          <h2 className="mt-4 font-serif text-3xl font-medium leading-snug tracking-tight text-[#064E3B] sm:text-4xl lg:text-5xl">
            Little shifts, <em className="text-[#059669]">lasting</em> change
          </h2>
        </Reveal>
        <div className="grid grid-cols-1 gap-6 md:grid-cols-3 lg:gap-8">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.tag} delay={i * 0.1}>
              <figure
                data-testid="testimonial-card"
                className="flex h-full flex-col rounded-3xl border border-[#064E3B]/12 bg-[#F7F4EB] p-7 transition-transform duration-300 hover:-translate-y-1.5 hover:shadow-[0_18px_40px_-18px_rgba(6,78,59,0.3)]"
              >
                <Quote size={26} className="text-[#D97706]" aria-hidden="true" />
                <blockquote className="mt-4 flex-1 font-serif text-lg leading-relaxed text-[#1C2826]">
                  &ldquo;{t.quote}&rdquo;
                </blockquote>
                <figcaption className="mt-6">
                  <div className="mb-2 flex gap-0.5 text-[#D97706]" aria-label="5 star rating">
                    {Array.from({ length: 5 }).map((_, s) => (
                      <Star key={s} size={14} fill="currentColor" strokeWidth={0} />
                    ))}
                  </div>
                  <span className="block text-sm font-semibold text-[#064E3B]">{t.author}</span>
                  <span className="mt-1 inline-block rounded-full bg-[#ECFDF5] px-2.5 py-0.5 text-[11px] font-semibold text-[#059669]">
                    {t.tag}
                  </span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
